import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  standalone: false,
  selector: 'app-order-dropdown',
  templateUrl: './order-dropdown.component.html',
  styleUrls: ['./../dropdown.component.scss']
})
export class OrderDropdownComponent {
  @Input() options: Array<any>;
  activeTitle: string;
  isDropDown: boolean;

  @Output() readonly selectedOption: EventEmitter<any> = new EventEmitter<any>();

  onToggle(): void {
    this.isDropDown = !this.isDropDown;
  }

  onSelectOption(option: any): void {
    this.activeTitle = option.client + '-' + option.name + '-' + option.upisId;
    this.selectedOption.emit(option);
  }

  trackByFunction(index: number): number {
    return index;
  }
}
